
<style>
.option-header {
  padding-top: 10px;
  padding-bottom: 20px;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <b-row>
      <b-col>
        <b-card>
          <div class="option-header">
            <b-row class="form-select">
              <b-col cols="1">
                <span class="vertical-center">Field:</span>
              </b-col>
              <b-col cols="3">
                <b-form-select
                  v-model="selectedField"
                  :options="comboFieldOption"
                  @change="fieldChangedEvent"
                ></b-form-select>
              </b-col>
              <b-col cols="1">
                <span class="vertical-center">Pad:</span>
              </b-col>
              <b-col cols="3">
                <b-form-select
                  v-model="selectedPad"
                  :options="comboPadOption"
                  @change="padChangedEvent"
                ></b-form-select>
              </b-col>
              <b-col cols="1">
                <span class="vertical-center">Well:</span>
              </b-col>
              <b-col cols="3">
                <b-form-select
                  v-model="selectedWell"
                  :options="comboWellOption"
                  @change="wellChangedEvent"
                ></b-form-select>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row> -->
    <div>
      <WellInfo
        :field-id="selectedField"
        :pad-id="selectedPad"
        :well-id="selectedWell"
      />
      <div>
        <b-row>
          <b-col>
            <b-card title="Bit Performance">
              <hr/>
              <BitPerformance
                style="padding-top: 10px"
                :well-id="selectedWell"
              />
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- Export  -->
    <div>
      <b-toast id="toastExportBitPerformance" solid :no-auto-hide="true">
        <template v-slot:toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">Generate Report</strong>
            <small class="text-muted mr-2"></small>
          </div>
        </template>
        <b-spinner small></b-spinner>
        Export progress : {{ exportProgress }}%
      </b-toast>
      <vue-html2pdf
        :show-layout="false"
        :preview-modal="true"
        :paginate-elements-by-height="2000"
        filename="rigid.pdf"
        :pdf-quality="2"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        @progress="onProgress($event)"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <section class="pdf-item">
            <div style="padding-left: 20px">
              <div>
                <b-row>
                  <b-col>
                    <div style="padding: 30px 0px 0px 25px; width: 97%">
                      <img
                        :src="currentUser ? currentUser.logo : ''"
                        alt
                        height="40"
                      />
                      <div style="padding-top: 10px; font-size: 12px">
                        <table style="font-weight: bold">
                          <tr>
                            <td style="width: 110px">Company</td>
                            <td>: {{ currentUser.orgName }}</td>
                          </tr>
                          <tr>
                            <td>Report Name</td>
                            <td>: Days vs Depth vs Cost vs Days/10k Report</td>
                          </tr>
                          <tr>
                            <td>Generated By</td>
                            <td>: WellKey System</td>
                          </tr>
                          <tr>
                            <td>Date</td>
                            <td>: {{ dateExport }}</td>
                          </tr>
                        </table>
                        <hr />
                        <span
                          >This report containing PT and NPT activities.</span
                        >
                      </div>
                    </div>
                    <b-card title="Days vs Depth vs Cost">
                      <BitPerformance
                        :well-id="selectedWell"
                        :export-needs="true"
                      />
                    </b-card>
                  </b-col>
                </b-row>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>
    </div>
  </Layout>
</template>

<script>
import startCase from 'lodash/startCase'
import appConfig from '@src/app.config'
import { tableAction } from '@utils/mixins'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { authComputed, fieldMethods } from '@state/helpers'
import BitPerformance from '@components/dashboard/bit-performance.vue'
import WellInfo from '@components/dashboard/well-info'
import VueHtml2pdf from 'vue-html2pdf'
/**
 * Well information component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, BitPerformance, WellInfo, VueHtml2pdf },
  mixins: [tableAction],
  data() {
    return {
      title: 'Bit Performance Dashboard',
      exportProgress: 0,
      dateExport: this.moment().format('MMM D, YYYY H:m'),
      comboFieldOption: [],
      comboPadOption: [],
      comboWellOption: [],
      selectedField: null,
      selectedPad: null,
      selectedWell: null,
      items: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Dashboard',
          to: { name: 'dashboard' },
        },
        {
          text: 'Bit Performance',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
    wellInformation: function () {
      let result = []
      this.currentWell &&
        Object.keys(this.currentWell).map((item, i) => {
          if (i % 4 === 0 && i !== 0) {
            result.push({
              type: 'column',
            })
          }
          result.push({
            label: startCase(item),
            value: this.currentWell[item],
          })
        })
      // console.log(this.splitEvery(result)[0].list)
      return this.splitEvery(result)[0].list
    },
  },
  created() {
    this.retrieveComboOptionField()
    this.selectedField = this.wellInformation[3][0].value.fieldId
    this.retrieveComboOptionPad(this.selectedField)
    this.selectedPad = this.wellInformation[3][0].value.padId
    this.retrieveComboOptionWell(this.selectedPad)
    this.selectedWell = this.wellInformation[0][0].value
  },
  methods: {
    ...fieldMethods,
    retrieveComboOptionField() {
      this.comboFieldOption = []
      this.selectedField = null
      this.selectedPad = null
      this.selectedWell = null
      this.getFields({ params: {} }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.fieldId, text: item.fieldName }
          this.comboFieldOption.push(opt)
        })
      })
    },
    retrieveComboOptionPad(fieldId) {
      this.comboPadOption = []
      this.comboWellOption = []
      this.selectedPad = null
      this.selectedWell = null
      this.getPads({ params: { fieldId: fieldId } }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.padId, text: item.padName }
          this.comboPadOption.push(opt)
        })
      })
    },
    retrieveComboOptionWell(padId) {
      this.comboWellOption = []
      this.selectedWell = null
      this.getWells({
        params: { fieldId: this.selectedField, padId: padId },
      }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.wellId, text: item.wellName }
          this.comboWellOption.push(opt)
        })
      })
    },
    fieldChangedEvent(fieldId) {
      this.retrieveComboOptionPad(fieldId)
    },
    padChangedEvent(padId) {
      this.retrieveComboOptionWell(padId)
    },
    wellChangedEvent(wellId) {
      this.selectedWell = wellId
    },
    getLabelName(label) {
      return startCase(label)
    },
    exportPdf() {
      this.$refs.html2Pdf.generatePdf()
      this.$bvToast.show('toastExportBitPerformance')
    },
    onProgress(evt) {
      this.exportProgress = evt
      if (evt === 100) {
        this.$bvToast.hide('toastExportBitPerformance')
      }
    },
  },
}
</script>
